import { StrapiV4FAQ } from '../atoms-components/faq/faq'
import { StrapiV4FAQv1 } from '../atoms-components/faq/faqV1'

export type TPropsFAQMolecule = {
  faqs: Array<{
    id?: number
    question: string
    answer: string
  }>
  json_placeholder?: object
  variant?: 'v0' | 'v1'
}

export function StrapiV4FAQs(props: TPropsFAQMolecule) {
  const { faqs, json_placeholder = {}, variant } = props
  return (
    <div>
      {faqs.map((el, idx) => {
        return variant === 'v0' ? (
          <StrapiV4FAQ
            answer={el.answer}
            question={el.question}
            key={idx}
            json_placeholder={json_placeholder}
          />
        ) : (
          <StrapiV4FAQv1
            answer={el.answer}
            question={el.question}
            key={idx}
            json_placeholder={json_placeholder}
          />
        )
      })}
    </div>
  )
}
